import "./style.css";
import layout from "./layout.html";

export default class Italy {
  static selector = ".italy";

  constructor(block, { info }) {
    this.block = block;

    this.block.innerHTML = layout;
  }

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      resolve();
    });
  };
}
